<template>
  <div class="footer-outer-wrp" :style="{background:background}">
      <div class="content-box footer-inner-wrp">
          <p>Shall we chat?</p>
          <router-link 
            :style="{color:color}" 
            to="/contact"
            >Let’s talk about<br class="footer-br-1"/> your<br class="footer-br-2"/> project <img :src="arrowImg" style="vertical-align: middle;"></router-link>
      </div>
  </div>
</template>

<script>
export default {
    props:{
        background:String,
        color:String
    },

    computed:{
        arrowImg(){
            return this.color === '#161717'?
                require('../../assets/img/black-arrow-right.svg')
                :require('../../assets/img/white-arrow-right.svg')
        }
    }
}
</script>

<style>
.footer-outer-wrp{
    padding: 158px 0 141px 0;
}

.footer-outer-wrp p{
    font-size: 30px;
    font-weight: 300;
    color: #818181;
    margin-bottom: 2%;
}

.footer-outer-wrp a{
    font-size: 66px;
    line-height: 81px;
    font-weight: 600;
}

.footer-br-1{
    display: none;
}

/* @media screen and (max-width: 1366px){
    .footer-outer-wrp p{
        font-size: 26px;
    }
    .footer-outer-wrp a{
        font-size: 46px;
        line-height: 51px;
    }
} */

@media screen and (max-width: 800px){
    .footer-outer-wrp{
        padding: 84px 0 110px 0;
    }
    .footer-outer-wrp p{
        margin-bottom: 6%;
        font-size: 26px;
    }
    .footer-outer-wrp a{
        font-size: 46px;
        line-height: 51px;
    }
    .footer-br-1{
        display: block;
    }
    .footer-br-2{
        display: none;
    }
}

@media screen and (max-width: 320px){
    .footer-outer-wrp{
        padding: 84px 10px 110px 10px;
    }
    .footer-outer-wrp p{
        font-size: 23px;
    }
    .footer-outer-wrp a{
        font-size: 36px;
        line-height: 51px;
    }
}
</style>